import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AddonPackageService } from 'projects/apex/src/app/features/addon/services/addon-package/addon-package.service';
import { AddonPackage } from 'projects/apex/src/app/models/addon-package';
import { Apartment } from 'projects/apex/src/app/models/apartment';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { t } from '../../../../../components/translate/translate.function';

@Component({
  selector: 'apex-client-addon-package-detail-page',
  templateUrl: './addon-package-detail.component.html',
  styleUrls: ['./addon-package-detail.component.scss'],
})
export class ClientAddonPackageDetailPageComponent implements OnInit, OnDestroy {
  apartment: Apartment;
  package: AddonPackage & { priceIn?: number; priceOut?: number; availabilityFrom?: Date; availabilityTo?: Date };
  packageId: string; // UUID

  loading = true;
  ordering = false;
  error: string;
  packagePrice: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private addonPackageService: AddonPackageService,
  ) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data;

    this.apartment = data.apartment;

    this.packageId = this.route.snapshot.params['packageId']; // UUID is string

    if (!this.packageId || !this.apartment?.id) {
      this.error = t('Invalid package or apartment.');
      this.loading = false;

      return;
    }

    this.loadPackageDetails();
  }

  calculatePackagePrice(): void {
    this.packagePrice = this.package.priceOut;

    if (this.package.vatPercentage && this.package.vatPercentage > 0) {
      this.packagePrice = this.packagePrice * (1 + this.package.vatPercentage / 100);
    }
  }

  loadPackageDetails(): void {
    this.subscriptions.push(
      this.addonPackageService
        .getOneForApartment(this.apartment.id, this.packageId)
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.package = response.Entity;
            this.loading = false;
            this.calculatePackagePrice();
          },
          error: () => {
            this.error = t('Failed to load package details.');
            this.loading = false;
          },
        }),
    );
  }

  orderPackage(): void {
    if (!this.apartment?.id || !this.packageId || this.ordering) {
      return;
    }

    this.ordering = true;

    this.subscriptions.push(
      this.addonPackageService
        .createOrder(this.apartment.id, this.packageId)
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            if (response.redirectUrl) {
              window.location.href = response.redirectUrl;
            }
          },
          error: () => {
            this.ordering = false;
            this.error = t('Failed to create order. Please try again.');
          },
        }),
    );
  }

  back(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s?.unsubscribe());
  }
}
